/* eslint-disable import/no-cycle */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable react/require-default-props */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable react/no-unused-prop-types */
/* eslint-disable @typescript-eslint/no-unnecessary-type-assertion */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable no-shadow */
/* eslint-disable react-hooks/exhaustive-deps */

import React, { useCallback, useMemo, FC } from 'react';
import DOMPurify from 'dompurify';
import { useTranslation } from 'react-i18next';
import {
  Box,
  theme,
  Text,
  SystemStyleObject,
  Popover,
  PopoverArrow,
  PopoverBody,
  PopoverContent,
  PopoverTrigger,
  PopoverHeader,
} from '@chakra-ui/core';
import TextInput from './TextInput';
import { useGetItemProperty } from '../hooks/useGetItemProperty';
import { useUpdateFormItem } from '../hooks/useUpdateFormItem';
import withToggleVisibility from '../utils/withToggleVisibility';
import { TextWithTranslationsT } from '../types';
import { ValidationTypeEnum } from '../hooks/useHireFormErrorHandling';
import { useStoreState } from '../../../../models/hooks';
import { updateMissingTranslations, attachDataTag } from '../utils';

interface FormTextInputProps {
  fieldId: string;
  startWithEditView?: boolean;
  value: string;
  // path: PathT;
  placeholder?: string;
  onBlur?: () => void;
  isAdvanced?: boolean;
}

const FormTextInputComponent: FC<FormTextInputProps> = React.memo(function FormElementTextBuilderComponent({
  fieldId,
  // path,
  placeholder,
  startWithEditView,
  onBlur,
  isAdvanced,
}: FormTextInputProps) {
  const language = useStoreState((state) => state.formBuilder.currentLanguage);
  const defaultLanguage = useStoreState((state) => state.formBuilder.defaultLanguage);
  const languages = useStoreState((state) => state.formBuilder.availableLanguages);

  const currentFieldValue = useGetItemProperty(fieldId, 'text');
  const handleOnChange = useUpdateFormItem();

  const handleChange = useCallback(
    (newTextValueForCurrentLanguage: string) => {
      const currentTextObject = currentFieldValue || {};
      const updatedDefaultValue = { ...currentTextObject, [language]: newTextValueForCurrentLanguage };

      const finalValueWithTranslations = updateMissingTranslations(
        { text: updatedDefaultValue } as any,
        'text',
        defaultLanguage,
        languages,
      );
      handleOnChange(fieldId, finalValueWithTranslations);
      onBlur?.();
    },
    [handleOnChange, language, defaultLanguage, languages],
  );

  const currentLanguageLabel = useMemo(() => {
    return currentFieldValue?.[language] ?? '';
  }, [currentFieldValue, language]);

  return (
    <Box className="hide-in-drag-preview">
      <TextInput
        fieldId={fieldId}
        property="text"
        innerPath={language}
        label={currentLanguageLabel}
        value={currentFieldValue?.text as TextWithTranslationsT | undefined}
        placeholder={placeholder}
        onLabelChange={handleChange}
        startWithEditView={startWithEditView}
        language={language}
        isAdvanced={isAdvanced || false}
        // path={path}
      />
    </Box>
  );
});
const FormTextInputComponentWrapper = withToggleVisibility(FormTextInputComponent);

export const TextPreviewElement = ({
  value,
  error,
  placeholderText,
  onClick,
  sx,
}: {
  value: string;
  error?: string;
  placeholderText?: string;
  onClick?: () => void;
  sx?: SystemStyleObject | undefined;
}) => {
  const { t } = useTranslation('hrFormTemplate');

  const hasError = !!error;
  return (
    <Box sx={{ ...sx }}>
      <Popover placement="bottom-start" isLazy trigger="hover">
        <PopoverTrigger>
          <Box
            minHeight="0.8em"
            outline="1px solid transparent"
            dangerouslySetInnerHTML={{
              __html: value?.length
                ? DOMPurify.sanitize(attachDataTag(value), {
                    ALLOWED_TAGS: ['p', 'br', 'strong', 'em', 'u', 'ol', 'ul', 'li', 'span'],
                    ALLOWED_ATTR: ['data-tag', 'class'],
                  })
                : `<p style="color: ${hasError ? theme.colors.red[500] : theme.colors.gray[400]}">${placeholderText}</p>`,
            }}
            sx={{
              color: theme.colors.gray[600],
              paddingY: 1,
              paddingX: hasError ? 2 : 0,
              borderRadius: 'md',
              transition: 'padding 200ms ease-in-out, outline 100ms ease-in-out',
              outlineColor: hasError ? theme.colors.red[500] : 'transparent',
              '& ol, & ul': { margin: 'revert', padding: 'revert' },
              '& p': { marginBlockStart: '0.2em', marginBlockEnd: '0.2em' },
              '& .quill-custom-tag': {
                fontWeight: 'bold',
                backgroundColor: theme.colors.blue[50],
                padding: '0.1em 0.3em',
                borderRadius: 'md',
              },
              position: 'relative',
              zIndex: 0,
            }}
            onClick={onClick}
            _hover={{
              outlineColor: hasError ? theme.colors.red[500] : theme.colors.gray[300],
              paddingX: 2,
            }}
            cursor="text"
            fontSize="sm"
            data-testid="text-editor-preview"
          />
        </PopoverTrigger>
        <PopoverContent boxShadow="xl">
          <PopoverHeader fontWeight="semibold" fontSize="sm">
            {t('formBuilder.infoTooltips.text.title')}
          </PopoverHeader>
          <PopoverArrow />
          <PopoverBody>
            <Text fontSize="sm">{t('formBuilder.infoTooltips.text.description')}</Text>
          </PopoverBody>
        </PopoverContent>
      </Popover>
      {hasError && (
        <Text fontSize="xs" color="red.500" mt={1}>
          {error}
        </Text>
      )}
    </Box>
  );
};
const FormTextInput = ({ fieldId, placeholder, isAdvanced }: { fieldId: string; placeholder?: string; isAdvanced: boolean }) => {
  const { t } = useTranslation('hrFormTemplate');
  const currentLanguage = useStoreState((state) => state.formBuilder.currentLanguage);

  const currentFieldValue = useGetItemProperty(fieldId, 'text');

  const placeholderText = placeholder || t('formBuilder.editorPlaceholder.text') || 'Enter text...';

  return (
    <FormTextInputComponentWrapper
      initialValue={currentFieldValue!}
      validate={(callback, value) => {
        callback(value);
      }}
      currentLanguage={currentLanguage}
      // path={fullPathToTextData}
      validationType={ValidationTypeEnum.TEXT}
      fieldId={fieldId}
      innerPath={`text.${currentLanguage}`}
      placeholder={placeholderText}
      previewComponent={(value, error, placeholder) => (
        <TextPreviewElement value={value} error={error} placeholderText={placeholder} />
      )}
      isAdvanced={isAdvanced}
    />
  );
};
export default FormTextInput;
